<template>
  <div class="footer">
      @본 페이지는 <a class="link-boj" href="https://www.acmicpc.net">BOJ online judge</a>의 클론 페이지입니다. <br>
      2021 김덕휘 some right reserved
  </div>
</template>

<script>
export default {

}
</script>

<style>
.footer{
    bottom : 0;
    background-color : #252525;
    left : 0;
    color : white;
    height : min(150px);
    padding : 20px;
}
.link-boj{
    text-decoration: none;
    color : #c0bebe;
}
</style>